import React from "react";
import PropTypes from "prop-types";
import { useSelector } from "react-redux";
import Image from "../image/image";
import { Link } from "react-router-dom";
import useSupporters from "./use-supporters";

const SupportersList = () => {
  const { supporters } = useSupporters();
  return (
    <ul className="supporters-list">
      {supporters.map((supporter) => (
        <li className="supporters-list-item" key={supporter.id}>
          {supporter.fieldLink?.uri ? (
            <Link
              to={supporter.fieldLink?.uri?.path}
              target="_blank"
              rel="noreferer"
            >
              <Image data={supporter.fieldMediaImage} />
            </Link>
          ) : (
            <Image data={supporter.fieldMediaImage} />
          )}
        </li>
      ))}
    </ul>
  );
};

SupportersList.propTypes = {};

export default SupportersList;
